import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { ContactType_Enum } from '@weave/schema-gen-ts/dist/shared/persons/v3/enums.pb';
import { IconName } from '@frontend/icons';
import { formatPhoneNumber } from '@frontend/phone-numbers';

type PhoneNumberMatch = {
  phoneNumber: string;
  iconName: IconName;
};

export function getPhoneMatches(searchValue: string, contactInfo: Person['contactInfo']): PhoneNumberMatch[] {
  const phoneRegex = new RegExp('(?:\\(\\d{3}\\)|\\d{3})(?:[-\\s]?\\d){0,7}');
  const phoneMatch = phoneRegex.test(searchValue);

  if (!phoneMatch) {
    return [];
  }

  const searchValueDigits = searchValue.match(/\d/g)?.join('');

  if (!searchValueDigits) {
    return [];
  }

  return (
    contactInfo?.reduce((acc: PhoneNumberMatch[], contact) => {
      if (contact.type.startsWith('PHONE')) {
        const contactDigits = contact.destination;

        if (contactDigits && contactDigits.includes(searchValueDigits)) {
          acc.push({
            phoneNumber: formatPhoneNumber(contactDigits),
            iconName: phoneNumberMap(contact.type),
          });
        }
      }

      return acc;
    }, []) ?? []
  );
}

const phoneNumberMap = (phoneNumberMap: ContactType_Enum): IconName => {
  switch (phoneNumberMap) {
    case ContactType_Enum.PHONE_HOME:
      return 'home-small';
    case ContactType_Enum.PHONE_MOBILE:
      return 'cell-phone-small';
    case ContactType_Enum.PHONE_WORK:
      return 'building-small';
    default:
      return 'cell-phone-small';
  }
};
